<template lang="">
    <div>
        <el-select filterable multiple v-model="subcategories_selected">
            <el-option v-for="s in subcategories" :label="`${s.subcategory_name }`" :value="s.id" :key="s.id"></el-option>
        </el-select>
    </div>
</template>
<style>

</style>
<script>

import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';

export default {
    name: 'pages-subcategory-select',
    data: function(){
        return {
            subcategories_selected: this.value,
        }
    },
    created() {
    },
    computed: {

    },
    watch:{
        subcategories_selected: function(subcategories_selected) {
            this.$emit('input', subcategories_selected);
        }
    },
    props: ['value', 'subcategories'],
    components:{
        ElSelect,
        ElOption
    },
    methods:{

    }
}
</script>
